import { configureStore, combineReducers } from '@reduxjs/toolkit';
import userReducer from '../user/UserSlices';
import permissionsReducer from '../Permissions/UserPermissionsSlice.js';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage
import { persistReducer, persistStore } from 'redux-persist';

// Persist config
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', 'permissions'], // only persist the 'user' and 'permissions' slices ***NOTE: THIS IS NOT BEST PRACTICE TO whitelist permissions BUT DONE FOR SIMPLICITY***
};

const rootReducer = combineReducers({
  user: userReducer,
  permissions: permissionsReducer, 
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const Store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, 
    }),
});

export const persistor = persistStore(Store);

export default Store;
